import { render, staticRenderFns } from "./oil.vue?vue&type=template&id=39c83d20&scoped=true&lang=pug&"
import script from "./oil.vue?vue&type=script&lang=coffee&"
export * from "./oil.vue?vue&type=script&lang=coffee&"
import style0 from "./oil.vue?vue&type=style&index=0&id=39c83d20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c83d20",
  null
  
)

export default component.exports